import { useState, useEffect, useCallback } from 'react';
import debounce from 'lodash/debounce';

const DEBOUNCE_WAIT = 100;
const MOBILE_BREAKPOINT = 1024;

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth < MOBILE_BREAKPOINT;
  });

  const handleResize = useCallback(
    debounce(() => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    }, DEBOUNCE_WAIT),
    []
  );

  useEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      handleResize.cancel();
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return isMobile;
};
